
export const ipfsCore = '0.17.0'
export const commit = 'e8b7b66bfa98c2a1c0d0bfc19f698d7d00b6c888'
export const interfaceIpfsCore = '^0.157.0'
